// extracted by mini-css-extract-plugin
export var body = "styles-module--body--zpTwr";
export var box = "styles-module--box--+WZdM";
export var injuryCare = "styles-module--injuryCare--lmnLe";
export var label = "styles-module--label--4dxA4";
export var src = "styles-module--src--WBYWt";
export var summaryContent = "styles-module--summaryContent--RcVkP";